/*
 * @Author: your name
 * @Date: 2023-12-21 10:49:46
 * @LastEditTime: 2024-08-31 15:14:33
 * @LastEditors: your name
 * @Description: 
 * @FilePath: \web_BullyingPrevention\src\http\config.js
 * 可以输入预定的版权声明、个性签名、空行等
 */

import { syncSessionAuthFromLocation } from '@/utils/sessionAuth'

console.log(window.location.href)
syncSessionAuthFromLocation(window.location.href)

let url = process.env.VUE_APP_BASE_API
if (sessionStorage.getItem('api') || (url && url.includes('fblv2'))) {
  url = 'https://api.qingzhou.link/fblv2'
  sessionStorage.setItem('api', true)
}

export default {
    method: 'get',
    // 基础url前缀
    baseUrl: url, // api 的 base_url
    nodeEnv: process.env.NODE_ENV,
    // 请求头信息
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': sessionStorage.getItem('token')
    },
    // 参数
    data: {},
    // 设置超时时间
    timeout: 2000000,
    // 携带凭证（暂时关闭，为了支持SpringBoot后端跨域）
    // 扩展阅读：https://blog.csdn.net/liyuling52011/article/details/80013725，https://blog.csdn.net/luoyong123456/article/details/51306227
    withCredentials: false,
    // 返回数据类型
    responseType: 'json',
   
  }
